'use client'

export const LAST_ACTIVITY_STORAGE_KEY = 'auto-logout-last-activity'

export function writeLastActivity(now: number) {
  try {
    localStorage.setItem(LAST_ACTIVITY_STORAGE_KEY, String(now))
  } catch {}
}

export function readLastActivity(): number | null {
  try {
    const raw = localStorage.getItem(LAST_ACTIVITY_STORAGE_KEY)
    if (!raw) return null

    const parsed = Number(raw)
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null
  } catch {}

  return null
}

export function clearLastActivity(): void {
  try {
    localStorage.removeItem(LAST_ACTIVITY_STORAGE_KEY)
  } catch {}
}
